import clsx from 'clsx';

interface ButtonType {
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  color?: 'primary' | 'outlined';
  fullWidth?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
}

export const ButtonV2 = (props: ButtonType) => {
  return (
    <button
      className={clsx(
        'relative flex h-[52px] cursor-pointer items-center justify-center rounded-sm border font-semibold uppercase',
        (!props.color || props.color === 'primary') &&
          'border-transparent bg-[linear-gradient(180deg,#3b3b3b,#373737)] text-[#fff] shadow-[2px_2px_4px_0_rgba(0,0,0,0.23),inset_0_1px_0_0_#4b4b4b] hover:bg-[linear-gradient(180deg,#525252,#494848)] hover:text-[#f2f2f2] hover:shadow-[2px_2px_4px_0_rgba(0,0,0,0.23),inset_0_1px_0_0_#8e8e8e]',
        props.color === 'outlined' &&
          'border-[#5d5d5d] bg-transparent text-[#fff] hover:bg-[linear-gradient(180deg,#525252,#494848)] hover:shadow-[2px_2px_4px_0_rgba(0,0,0,0.23),2px_2px_4px_0_rgba(0,0,0,0.23),inset_0_1px_0_0_#686868]',
        props.fullWidth && 'w-full',
        props.disabled && 'pointer-events-none !bg-[linear-gradient(180deg,#525252,#494848)] !text-[#f2f2f24d]',
        props.className,
      )}
      type={props.type || 'button'}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
};
